/* Plot & Harvest collection page (v2 3-10-2026): chooser, filters, sort, compare (spec rows), basket, read more, anchor offset */
(function () {
  'use strict';
  var SEP = '¦';
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  $$('[data-ph-col]').forEach(function (root) {
    var grid = $('[data-grid]', root);
    if (!grid) return;
    var cards = $$('[data-card]', grid);
    var noun = root.getAttribute('data-noun') || 'designs';
    var state = { type: '', pmin: 0, pmax: Infinity, kw: '', sort: 'featured' };
    var announce = '';

    /* ---- type chips, in rule order, with counts ---- */
    var order = (root.getAttribute('data-types') || '').split(SEP).filter(Boolean);
    var counts = {};
    cards.forEach(function (c) { var t = c.getAttribute('data-type'); if (t) counts[t] = (counts[t] || 0) + 1; });
    Object.keys(counts).forEach(function (t) { if (order.indexOf(t) < 0) order.push(t); });
    order = order.filter(function (t) { return counts[t]; });
    var typeBox = $('[data-type-chips]', root);
    if (typeBox) {
      if (order.length < 2) typeBox.hidden = true;
      else {
        var html = '<button type="button" class="ph-chip" aria-pressed="true" data-t="">All<span class="ph-chip__n">' + cards.length + '</span></button>';
        order.forEach(function (t) { html += '<button type="button" class="ph-chip" aria-pressed="false" data-t="' + esc(t) + '">' + esc(t) + '<span class="ph-chip__n">' + counts[t] + '</span></button>'; });
        typeBox.innerHTML = html;
      }
    }

    function matches(c, st) {
      var p = parseInt(c.getAttribute('data-price'), 10) || 0;
      if (st.type && c.getAttribute('data-type') !== st.type) return false;
      if (p < st.pmin || p >= st.pmax) return false;
      if (st.kw && (c.getAttribute('data-kw') || '').indexOf(st.kw) < 0) return false;
      return true;
    }
    function syncChips() {
      $$('[data-t]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-t') === state.type ? 'true' : 'false'); });
      $$('[data-pmin]', root).forEach(function (b) { b.setAttribute('aria-pressed', (+b.getAttribute('data-pmin') === state.pmin && +b.getAttribute('data-pmax') === state.pmax) ? 'true' : 'false'); });
      $$('[data-kw-chip]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kw-chip') === state.kw ? 'true' : 'false'); });
    }
    function apply() {
      var list = cards.slice();
      if (state.sort !== 'featured') {
        list.sort(function (a, b) {
          if (state.sort === 'title') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          var d = (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
          return state.sort === 'price-asc' ? d : -d;
        });
      } else {
        list.sort(function (a, b) { return +a.getAttribute('data-i') - +b.getAttribute('data-i'); });
      }
      var n = 0;
      list.forEach(function (c) { var ok = matches(c, state); c.hidden = !ok; if (ok) n++; grid.appendChild(c); });
      var cnt = $('[data-count]', root); if (cnt) cnt.textContent = n;
      var live = $('[data-sort-live]', root);
      if (live && announce) live.textContent = 'Showing ' + n + ' ' + noun + ', ' + announce;
      announce = '';
      var on = state.type || state.pmin || state.pmax !== Infinity || state.kw;
      $$('.ph-bar [data-reset]', root).forEach(function (b) { b.hidden = !on; });
      var empty = $('[data-empty]', root); if (empty) empty.hidden = n > 0;
      syncChips();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-t]');
      if (t) { state.type = t.getAttribute('data-t'); apply(); return; }
      var p = e.target.closest('[data-pmin]');
      if (p) {
        var mn = +p.getAttribute('data-pmin'), mx = +p.getAttribute('data-pmax');
        if (state.pmin === mn && state.pmax === mx) { state.pmin = 0; state.pmax = Infinity; } else { state.pmin = mn; state.pmax = mx; }
        apply(); return;
      }
      var k = e.target.closest('[data-kw-chip]');
      if (k) { var v = k.getAttribute('data-kw-chip'); state.kw = state.kw === v ? '' : v; apply(); return; }
      if (e.target.closest('[data-reset]')) { state.type = ''; state.pmin = 0; state.pmax = Infinity; state.kw = ''; apply(); }
    });
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () {
      state.sort = sort.value;
      var o = sort.options[sort.selectedIndex]; announce = 'sorted by ' + (o ? o.text.toLowerCase() : sort.value);
      apply();
    });

    /* ---- help me choose ---- */
    var opts = $$('[data-choose]', root);
    function chooseState(b) {
      return { type: b.getAttribute('data-ftype') || '', kw: b.getAttribute('data-fkw') || '', pmin: 0, pmax: Infinity };
    }
    opts.forEach(function (b) {
      var i = b.getAttribute('data-choose');
      var st = chooseState(b);
      var n = cards.filter(function (c) { return matches(c, st); }).length;
      var panel = $('[data-choose-panel="' + i + '"]', root);
      var nEl = panel && $('[data-choose-n]', panel); if (nEl) nEl.textContent = n;
      b.addEventListener('click', function () {
        opts.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        $$('[data-choose-panel]', root).forEach(function (pn) { pn.hidden = pn.getAttribute('data-choose-panel') !== i; });
      });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nx = opts[(opts.indexOf(b) + d + opts.length) % opts.length]; nx.focus(); nx.click();
      });
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-choose-apply]');
      if (!a) return;
      var b = $('[data-choose="' + a.getAttribute('data-choose-apply') + '"]', root);
      var st = chooseState(b);
      state.type = st.type; state.kw = st.kw; state.pmin = 0; state.pmax = Infinity;
      apply();
      var target = $('.ph-bar', root) || grid;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    opts.forEach(function (b) { b.addEventListener('click', function () { opts.forEach(function (o) { o.tabIndex = o === b ? 0 : -1; }); }); });

    /* ---- compare (max 3) ---- */
    var tray = $('[data-tray]', root), dlg = $('[data-cmp-dialog]', root), picked = [];
    var labels = (root.getAttribute('data-cmp-labels') || '').split(SEP);
    function syncCmp() {
      cards.forEach(function (c) {
        var box = $('[data-cmp-box]', c), on = picked.indexOf(c) >= 0;
        box.checked = on;
        box.disabled = !on && picked.length >= 3;
        box.parentNode.classList.toggle('is-off', box.disabled);
        c.classList.toggle('is-picked', on);
      });
      if (!tray) return;
      tray.hidden = !picked.length;
      $('[data-tray-n]', tray).textContent = picked.length;
      $('[data-tray-thumbs]', tray).innerHTML = picked.map(function (c) { var im = c.getAttribute('data-img'); return im ? '<img src="' + esc(im) + '" alt="">' : ''; }).join('');
      $('[data-cmp-open]', tray).disabled = picked.length < 2;
      var pad = picked.length ? tray.offsetHeight + 'px' : '';
      root.style.paddingBottom = pad;
    }
    grid.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cmp-box]')) return;
      var c = e.target.closest('[data-card]'), i = picked.indexOf(c);
      if (e.target.checked && i < 0 && picked.length < 3) picked.push(c);
      if (!e.target.checked && i >= 0) picked.splice(i, 1);
      syncCmp();
      var tt = tray && $('[data-tray-note]', tray);
      if (tt) tt.textContent = picked.length >= 3 ? ' (maximum reached)' : picked.length === 1 ? ' (pick one more)' : '';
    });
    var opener = null;
    var specMode = root.getAttribute('data-specs') === '1';
    var SPEC_ROWS = [
      ['Price (incl. VAT)', 'data-price-label'],
      ['Mesh size', 'data-sp-mesh'],
      ['Material', 'data-sp-mat'],
      ['Supplied size', 'data-sp-size'],
      ['Pack quantity', 'data-sp-pack'],
      ['UV treatment', 'data-sp-uv'],
      ['Intended use', 'data-sp-app']
    ];
    function rowsFor(list) {
      if (specMode) {
        return SPEC_ROWS.map(function (r) { return [r[0], list.map(function (c) { return (c.getAttribute(r[1]) || '').trim(); })]; });
      }
      return labels.map(function (lab, r) {
        return [lab, list.map(function (c) { var v = (c.getAttribute('data-cmp') || '').split(SEP)[r] || ''; return v === '—' ? '' : v; })];
      });
    }
    function openCmp() {
      if (!dlg || picked.length < 2) return;
      var h = '<table class="ph-cmp__t' + (specMode ? ' is-specs' : '') + '" data-n="' + picked.length + '"><caption class="ph-vh">Comparing ' + picked.length + ' products</caption><thead><tr><td class="ph-cmp__corner"></td>';
      picked.forEach(function (c) {
        var im = c.getAttribute('data-img'), url = esc(c.getAttribute('data-url')), t = esc(c.getAttribute('data-title'));
        h += '<th scope="col" class="ph-cmp__p">' + (im ? '<a href="' + url + '" tabindex="-1" aria-hidden="true"><img src="' + esc(im) + '" alt="" width="96" height="96"></a>' : '') + '<a class="ph-cmp__name" href="' + url + '">' + t + '</a></th>';
      });
      h += '</tr></thead><tbody>';
      rowsFor(picked).forEach(function (row) {
        var vals = row[1];
        if (vals.every(function (v) { return !v; })) return;   /* empty for every product: leave the row out */
        h += '<tr><th scope="row">' + esc(row[0]) + '</th>';
        vals.forEach(function (v) { h += v ? '<td>' + esc(v) + '</td>' : '<td class="is-na">Not specified</td>'; });
        h += '</tr>';
      });
      h += '</tbody></table>';
      var body = $('[data-cmp-body]', dlg);
      body.innerHTML = h;
      body.scrollLeft = 0;
      opener = document.activeElement;
      lockScroll(true);
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var hint = $('[data-cmp-hint]', dlg);
      if (hint) hint.hidden = !(body.scrollWidth > body.clientWidth + 4);
      var x = $('[data-cmp-close]', dlg); if (x) x.focus();
    }
    /* background scroll lock: Horizon scrolls the window on phones and .page-wrapper on desktop */
    var saved = null;
    function lockScroll(on) {
      var pw = document.querySelector('.page-wrapper');
      if (on) {
        saved = { y: window.pageYOffset, pw: pw ? pw.scrollTop : 0 };
        document.documentElement.classList.add('ph-cmp-open');
      } else {
        document.documentElement.classList.remove('ph-cmp-open');
        if (saved) {
          if (pw && pw.scrollTop !== saved.pw) pw.scrollTop = saved.pw;
          if (window.pageYOffset !== saved.y) window.scrollTo(0, saved.y);
        }
        saved = null;
      }
    }
    function onClose() {
      lockScroll(false);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    function closeCmp() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); onClose(); }
    if (tray) {
      $('[data-cmp-open]', tray).addEventListener('click', openCmp);
      $('[data-tray-clear]', tray).addEventListener('click', function () {
        var first = picked[0]; picked = []; syncCmp();
        var nt = $('[data-tray-note]', tray); if (nt) nt.textContent = '';
        var fb = first && $('[data-cmp-box]', first); if (fb) fb.focus({ preventScroll: true });
      });
    }
    if (dlg) {
      $('[data-cmp-close]', dlg).addEventListener('click', closeCmp);
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeCmp(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeCmp(); });
    }

    /* ---- add to basket without leaving the page (falls back to a normal submit) ---- */
    grid.addEventListener('submit', function (e) {
      var f = e.target.closest('.ph-col-add');
      if (!f || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', f), label = btn.textContent;
      var msg = $('.ph-col-msg', f.parentNode);
      if (!msg) { msg = document.createElement('p'); msg.className = 'ph-col-msg'; msg.setAttribute('role', 'status'); f.after(msg); }
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = 'Adding…';
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root_ + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          msg.className = 'ph-col-msg'; msg.innerHTML = 'Added. <a href="' + root_ + 'cart">View basket</a>';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-col', data: { itemCount: cart.item_count, source: 'ph-col' } } }));
        })
        .catch(function (err) {
          msg.className = 'ph-col-msg is-err';
          msg.textContent = (err && (err.description || err.message)) || 'Could not add this item. Please try again.';
        })
        .then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = label; });
    });

    /* ---- guide text: read more ---- */
    var seo = $('[data-seo]', root), more = $('[data-seo-more]', root);
    if (seo && more && seo.scrollHeight > 220) {
      seo.classList.add('is-clamped'); more.hidden = false;
      more.addEventListener('click', function () {
        var open = seo.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Read less' : 'Read more';
      });
    }

    /* ---- buying guide: job list starts folded on phones so the products stay close ---- */
    var gm = $('[data-guide-more]', root);
    if (gm && window.matchMedia) {
      var narrow = window.matchMedia('(max-width: 749px)');
      var setG = function () { gm.open = !narrow.matches; };
      setG();
      if (narrow.addEventListener) narrow.addEventListener('change', setG);
    }

    apply();

    /* ---- "Shop the range": the list has scroll-margin-top = header height + gap (CSS).
       If the page was opened with the fragment, re-align once the header has been measured. ---- */
    var list = $('[data-bar]', root) || grid.closest('.ph-col-list');
    if (list && location.hash && list.id && (location.hash.slice(1) === list.id || location.hash === '#ph-grid-' + list.id.replace('ph-shop-', ''))) {
      var realign = function () { list.scrollIntoView({ block: 'start' }); };
      if (document.readyState === 'complete') setTimeout(realign, 60);
      else window.addEventListener('load', function () { setTimeout(realign, 60); }, { once: true });
    }
  });
})();
